import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { easings } from "@apps/viewer/src/ts/config";

/**
 * Specification of the enter duration given in milliseconds.
 */
const ENTER_DURATION = 325;

/**
 * Specification of the exit duration given in milliseconds.
 */
const EXIT_DURATION = 175;

/**
 * Simple css fade transition that'll fade the dropdown in / out when it's being
 * shown / hidden.
 */
// tslint:disable-next-line variable-name
export const Fade: React.FC<{
  children: (ref: RefObject<any>) => React.ReactNode;
}> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      timeout={{
        enter: ENTER_DURATION,
        exit: EXIT_DURATION,
      }}
      classNames="utils__lightbox__fade"
      nodeRef={ref}
    >
      <>
        {props.children(ref)}

        <style jsx global>{`
          /** Fade the lightbox into view */
          .utils__lightbox__fade-enter,
          .utils__lightbox__fade-appear {
            opacity: 0.001;
          }

          .utils__lightbox__fade-enter-active,
          .utils__lightbox__fade-appear-active {
            opacity: 1;
            transition: opacity ${ENTER_DURATION}ms linear;
          }

          /** Scale container into view */
          .utils__lightbox__fade-enter .lightbox__container,
          .utils__lightbox__fade-appear .lightbox__container {
            transform: scale(0.75);
          }

          .utils__lightbox__fade-enter-active .lightbox__container,
          .utils__lightbox__fade-appear-active .lightbox__container {
            transform: scale(1);
            transition: transform ${ENTER_DURATION * 0.8}ms
              ${easings.inOutQuart};
          }

          /** Fade lightbox out of view */
          .utils__lightbox__fade-exit {
            opacity: 1;
          }

          .utils__lightbox__fade-exit-active {
            opacity: 0.001;

            /** Apply transition */
            transition: opacity ${EXIT_DURATION}ms linear;
          }

          .utils__lightbox__fade-exit-done {
            opacity: 0;
          }
        `}</style>
      </>
    </CSSTransition>
  );
};
